module.exports = __webpack_public_path__ + "2e800e1a4a96bc219c6d64682e436665.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Pear@2x.png
// module id = 323
// module chunks = 0